import { isMock } from '../config'
import { checkoutMock } from './mock'
import { withOfflineCache } from '../offline-cache'
import { checkoutReal } from './real'
import type { CheckoutService } from './types'

const impl: CheckoutService = isMock('checkout') ? checkoutMock : checkoutReal

/** La salida (hora, instrucciones, cargos) sigue disponible sin conexión con la última copia (D18). */
export const checkoutService: CheckoutService = {
  getCheckout: (stay, lang, signal) => withOfflineCache(stay.guestCode, 'checkout', () => impl.getCheckout(stay, lang, signal)),
  setChecklistItem: (stay, id, done) => impl.setChecklistItem(stay, id, done),
  markLeft: (stay) => impl.markLeft(stay),
  getAfterStay: (stay, signal) => impl.getAfterStay(stay, signal),
}
export { checkoutGuideItem } from './shared'
export type { AfterStay, Checkout, CheckoutCharge, CheckoutService, CheckoutStay, ChecklistEntry, SuggestedDates } from './types'
